export default function (context, val) {
    let ag = context.state.list.filter(i=>{
        return i.code===val.code;
    })[0];
    context.dispatch(
        'finances/pay/rates/get',
        ({
            date: val.date,
            c1: val.currency,
            c2: context.rootState.finances.pay.form.CurrencyId,
            callback: (rate) => {
                ag.course = rate.course;
            }
        }),
        {root: true}
    );
}